import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import useFetcher from "@/utils/use-fetcher";

export interface NormalizeLineSheetParameter {
  agencyId: number;
  lineSheetSetId: number;
  lineSheetId: number;
}

export interface NormalizeLineSheetRequest {}

export interface NormalizeLineSheetResponse {}

export const normalizeLineSheetTemplateUrl =
  "/agencies/:agencyId/line-sheet-sets/:lineSheetSetId/line-sheets/:lineSheetId/normalize";

export const normalizeLineSheetKey: YWRKey<NormalizeLineSheetParameter> = {
  url: (parameter: NormalizeLineSheetParameter) => {
    return calcUrl(normalizeLineSheetTemplateUrl, parameter);
  },
  method: "put",
};

export default function useNormalizeLineSheet() {
  const fetcher = useFetcher<
    NormalizeLineSheetRequest,
    NormalizeLineSheetResponse
  >();
  return useYWR(normalizeLineSheetKey, fetcher);
}
